export const bloodgroups = [
    { value: 'a+', text: 'A+' },
    { value: 'a-', text: 'A-' },
    { value: 'b+', text: 'B+' },
    { value: 'b-', text: 'B-' },
    { value: 'o+', text: 'O+' },
    { value: 'o-', text: 'O-' },
    { value: 'ab+', text: 'AB+' },
    { value: 'ab-', text: 'AB-' },
  ];
  